import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { IAvailablePermissions } from '../types';

type Props = {
  children: React.ReactNode;
  permissions: IAvailablePermissions[];
};

export const PermissionsGuard = ({ children, permissions }: Props) => {
  const { hasPermissions } = usePermissions();

  if (!hasPermissions(permissions)) {
    return <Navigate replace to="/v360-app" />;
  }

  return <div>{children}</div>;
};
